<template>
  <v-autocomplete
    outlined
    clearable
    hide-details
    return-object
    hide-selected
    hide-no-data
    no-filter
    unique
    item-text="pessoa.nome"
    label="Transportadora"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs">
      <template v-slot:item="item">
        <slot name="item" v-bind:item="item">
          <px-chip-codigo-interno :codigo-interno="codigoInterno(item.item)"/>
          <span>{{ item.item.pessoa.nome }}</span>
        </slot>
      </template>
      <template v-slot:selection="item">
        <px-chip-codigo-interno :codigo-interno="codigoInterno(item.item)"/>
        <span>{{ item.item.pessoa.nome }}</span>
      </template>
    </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import TransportadoraService from '@/api/transportadora-service';
import { formatCnpj, hasAnyLetter } from '@/utils/regex-utils';

export default {
  props: {
    value: Object,
    path: {
      type: String,
      default: 'fornecedor/score',
    },
    searchByCode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    codigoInterno() {
      return transportadora => transportadora.codigoTransportadora || transportadora.codigoInterno;
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
    value() {
      if (this.value) {
        this.items = [this.value, ...this.items];
      }
    },
  },
  methods: {
    buildFilter(val) {
      const text = val || '';
      const cnpjQuery = !hasAnyLetter(text) ? ` or cnpj like "%${formatCnpj(text)}%"` : '';
      const filter = `nome like "%${text.toLowerCase()}%" or nomeCustomizado like "%${text.toLowerCase()}%"${cnpjQuery}`;
      return `${filter} order by nome`;
    },
    buildCodigoFilter(val) {
      if (this.searchByCode) {
        return val;
      }
      return undefined;
    },
    searchTransportadoras(val) {
      if (!val) {
        return;
      }
      if (this.localValue && this.localValue.pessoa.nome === val) {
        return;
      }
      this.loading = true;

      TransportadoraService.getTransportadorasCompra(this.path, {
        limit: 20,
        offset: 0,
        query: this.buildFilter(val),
        transportadoras: true,
        codigoInterno: this.buildCodigoFilter(val),
      })
        .then(({ data }) => {
          this.items = this.value ? [this.value, ...data.content] : data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchTransportadoras, 1000);
    if (this.value) {
      this.items = [this.value, ...this.items];
    }
  },
};
</script>
